module.exports = __webpack_public_path__ + "static/media/Directory_RVSKV.40be58e4.pdf";